import { render, staticRenderFns } from "./KreirajLiguLink.vue?vue&type=template&id=1d3b9836&scoped=true&"
import script from "./KreirajLiguLink.vue?vue&type=script&lang=js&"
export * from "./KreirajLiguLink.vue?vue&type=script&lang=js&"
import style0 from "./KreirajLiguLink.vue?vue&type=style&index=0&id=1d3b9836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3b9836",
  null
  
)

export default component.exports